import React, { useEffect, useState } from "react";
import { Text, View, Image, Modal, StyleSheet, FlatList, TouchableOpacity, useWindowDimensions } from "react-native";

import WooService from "../services/WooService";
import Config from "../config/Config";

const config = new Config();

const BalanceScreen = ({ navigation }) => {
  const { width, height } = useWindowDimensions();

  const [message, setMessage] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState();
  const [action, setAction] = useState();
  const [balanceOpenTime, setBalanceOpenTime] = useState();
  const [balanceModalVisible, setBalanceModalVisible] = useState(false);
  const [balanceInfo, setBalanceInfo] = useState([]);
  const [balanceEntries, setBalanceEntries] = useState([]);
  const [cashIn, setCashIn] = useState([]);
  const [cashOut, setCashOut] = useState([]);
  const [totals, setTotals] = useState({value: 0, sales: 0});

  const wooService = new WooService();

  const showBalanceInfo = async () => {
    try {
        setModalMessage("Carregando informações do caixa.\nPor favor, aguarde.");
        setModalVisible(true);
        const response = await wooService.getOpenBalance();
        if (response.data && response.data.length > 0) {
            const openTime = new Date(response.data[0].opentime);
            setBalanceOpenTime(openTime)
            setMessage(`O caixa foi aberto às ${openTime.toLocaleTimeString()} de ${openTime.toLocaleDateString()}.\nQual operação deseja realizar?`);
            setAction("close");
        } else {
            setMessage("O caixa ainda não foi aberto.\nDeseja abrir agora?");
            setAction("open");
        }
        setModalVisible(false);
    }
    catch(error) {
        console.log("Error: ", error);
        setModalMessage("Erro na comunicação com o servidor.\nDeseja tentar novamente?");
        setModalVisible(false);
        setAction("error");
    };
  }

  useEffect(() => {
    showBalanceInfo();
  }, []);

  const openCloseBalance = (action) => {
    if (action === "open" || action === "close") {
        navigation.navigate("CashBalance", {action: action, callback: showBalanceInfo});
    } else if (action === "error") {
      showCashBalance();
    }
  }

  const getBalanceEntries = (type) => {
    navigation.navigate("BalanceEntries", {action: type});
  }

  const getBalanceData = async (balanceId) => {
    setBalanceModalVisible(true);
    const response =  await wooService.getBalanceData(balanceId);
    setBalanceInfo(response.data.balance);
    setBalanceEntries(response.data.entries);
    setCashIn(response.data.cash_in);
    setCashOut(response.data.cash_out);
    let entriesTotals = await response.data.entries.reduce((accum, entry) => {
      return {value: accum.value + parseInt(entry.value), sales: accum.sales + (entry.sales ? entry.sales : 0)}
    }, {value: 0, sales: 0});
    setTotals(entriesTotals);
  }

  const showBalanceOpenCloseInfo = (openCloseCash, openCloseTime) => {
    const cashInfo = openCloseCash ? (openCloseCash/100).toFixed(2) : '...';
    let timeInfo = "...";
    if (openCloseTime) {
      const utcTime = new Date(openCloseTime + " GMT");
      timeInfo = utcTime ? (utcTime.toLocaleTimeString() + ' de ' + utcTime.toLocaleDateString()) : '...';
    }
    return cashInfo + " (" + timeInfo + ")";
  }

  return (
    <View>
        <Modal
            animationType="fade"
            transparent={true}
            visible={modalVisible}>
            <View style={styles.modalView}>
                <Text style={styles.modalText}>{modalMessage}</Text>
            </View>
        </Modal>
        <Modal
            animationType="fade"
            transparent={true}
            visible={balanceModalVisible}>
            <View style={styles.balanceModalView}>
                <View>
                  <Text style={styles.modalText}>Valor de abertura: R$ {showBalanceOpenCloseInfo(balanceInfo.opencash, balanceInfo.opentime)}</Text>
                  <Text style={styles.modalText}>Valor de fechamento: R$ {showBalanceOpenCloseInfo(balanceInfo.closecash, balanceInfo.closetime)}</Text>
                </View>
                <View style={{flexDirection: 'row', marginTop: 15}}>
                    <View>
                        <Text style={{alignSelf: 'center', fontWeight: 'bold'}}>Sangrias</Text>
                        <FlatList
                            data={cashOut}
                            keyExtractor={entry => entry.id.toString()}
                            numColumns={1}
                            renderItem={({ item }) => {
                                return (
                                    <View style={styles.listStyle}>
                                        <Text style={{width: 250, textAlign: 'center'}}>R$ {item.value ? (item.value/100).toFixed(2) : "-"}</Text>
                                    </View>
                                );
                            }}
                        />
                    </View>
                    <View>
                        <Text style={{alignSelf: 'center', fontWeight: 'bold'}}>Suprimentos</Text>
                        <FlatList
                            data={cashIn}
                            keyExtractor={entry => entry.id.toString()}
                            numColumns={1}
                            renderItem={({ item }) => {
                                return (
                                    <View style={styles.listStyle}>
                                        <Text style={{width: 250, textAlign: 'center'}}>R$ {item.value ? (item.value/100).toFixed(2) : "-"}</Text>
                                    </View>
                                );
                            }}
                        />
                    </View>
                </View>
                <View style={styles.contentContainer}>
                  <View style={styles.listHeader}>
                      <Text style={styles.headerTitle}>Forma de Pagamento</Text>
                      <Text style={styles.headerTitle}>Recebido</Text>
                      <Text style={styles.headerTitle}>Vendido</Text>
                  </View>
                  <FlatList
                      data={balanceEntries}
                      LisHeaderComponent={<Text></Text>}
                      ListFooterComponent={<Text></Text>}
                      keyExtractor={entry => entry.id.toString()}
                      numColumns={1}
                      renderItem={({ item }) => {
                          return (
                              <View style={styles.listStyle}>
                                  <Text style={{width: 250, fontWeight: 'bold'}}>{item.paymentmethod}</Text>
                                  <Text style={{width: 250}}>R$ {item.value ? (item.value/100).toFixed(2) : "-"}</Text>
                                  <Text style={{width: 250}}>R$ {item.sales ? (item.sales/100).toFixed(2) : "-"}</Text>
                              </View>
                          );
                      }}
                  />
                  <View style={styles.listHeader}>
                      <Text style={styles.headerTitle}>Total</Text>
                      <Text style={styles.headerTitle}>R$ {(totals.value/100).toFixed(2)}</Text>
                      <Text style={styles.headerTitle}>R$ {(totals.sales/100).toFixed(2)}</Text>
                  </View>
                </View>
                <TouchableOpacity style={styles.buttons} onPress={() => setBalanceModalVisible(false)}>
                    <Text style={styles.buttonText}>Voltar</Text>
                </TouchableOpacity>
            </View>
        </Modal>
        {0 == 1 &&
          <Image style={styles.customerLogo} source={config.HOME_LOGO} />
        }
        <Text style={styles.titleText}>{message}</Text>
        <View style={{marginTop: 15}}>
            {action === "open" &&
                <TouchableOpacity style={styles.buttons} onPress={() => openCloseBalance(action)}>
                    <Text style={styles.buttonText}>Abrir o Caixa</Text>
                </TouchableOpacity>
            }
            {action === "close" && 
                <View>
                <TouchableOpacity style={styles.buttons} onPress={() => getBalanceEntries("cash-out")}>
                    <Text style={styles.buttonText}>Sangria</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.buttons} onPress={() => getBalanceEntries("cash-in")}>
                    <Text style={styles.buttonText}>Suprimento</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.buttons} onPress={() => openCloseBalance(action)}>
                    <Text style={styles.buttonText}>Fechar o Caixa</Text>
                </TouchableOpacity>
                </View>
            }
            <TouchableOpacity style={styles.buttons} onPress={() => getBalanceData()}>
                <Text style={styles.buttonText}>Conferir último caixa</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={() => navigation.goBack()}>
                <Text style={styles.buttonText}>Voltar</Text>
            </TouchableOpacity>
        </View>
    </View>);
};

const styles = StyleSheet.create({
  verticalLayout: {
    flexDirection: 'column',
    alignSelf: 'center'
  },
  horizontalLayout: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  titleText: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: 'center'
  },
  contentContainer: {
    paddingVertical: 10,
    paddingHorizontal: 30
  },
  listHeader: {
    marginVertical: 10,
    flexDirection: 'row'
  }, 
  headerTitle: {
    width: 250,
    fontSize: 17,
    fontWeight: 'bold',
    color: "#F0A22E"
  },
  listStyle: {
    margin: 5,
    flexDirection: 'row'
  },
  buttons: {
    backgroundColor: '#F0A22E',
    width: 400,
    marginVertical: 10,
    padding: 15,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
    fontSize: 20,
    fontWeight: 'bold',
    alignSelf: 'center'
  },
  customerLogo: {
    marginTop: 40,
    marginBottom: 20,
    alignSelf: 'center',
    width: 160,
    height: 80,
    resizeMode: 'contain'
  },
  waitBox: {
    justifyContent: 'center',
    alignSelf: 'center',
    width: 300,
    height: 120,
    backgroundColor: 'white',
    padding: 20,
    marginTop: 80,
    borderRadius: 10
  },
  waitText: {
    fontSize: 17,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  modalView: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 200,
    backgroundColor: "white",
    borderRadius: 20,
    paddingVertical: 70,
    paddingHorizontal: 70,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  balanceModalView: {
    alignItems: "center",
    alignSelf: "center",
    marginTop: 0,
    backgroundColor: "white",
    borderRadius: 20,
    paddingVertical: 12,
    paddingHorizontal: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  modalText: {
    fontSize: 17,
    fontWeight: "bold",
    textAlign: 'center',
    marginTop: 5
  }
});

export default BalanceScreen;